import React from "react";
import img from "../../assets/computer.png";
import { useEffect, useState } from "react";
import Logo from "../../assets/logo.png";
import video from "../../assets/5262343_Above_Aerial_Area_1920x1080.mp4";
// import { CiUser } from "react-icons/ci";
import { PiEyeThin } from "react-icons/pi";
// import { HiOutlineLockClosed } from "react-icons/hi2";
import { Link, useLocation } from "react-router-dom";
import { useMyContext } from "../../context/MyContext";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import axios from "axios";
import { API_BASE_URL, api } from "../../config/api";

const UserRegistration = () => {
  const navigate = useNavigate();
  const { setRole, role, login } = useMyContext();

  // const setrole = context.setrole
  const loc = useLocation();
  const [ispass, setispass] = useState(true);
  const [data, setData] = useState({
    name: "",
    jobTitle: "",
    company: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);
  // console.log(loc.pathname)
  const pass = () => {
    if (ispass) {
      setispass(false);
    } else {
      setispass(true);
    }
  };

  const handleLogin = async () => {
    setLoading(true);

    try {
      const res = await api.post(`/mail/user-registration`, data);
      if (res?.status === 200) {
        message.success("You data has been submitted to admin");
        setData({ name: "", email: "", jobTitle: "", company: "" });
      } else {
        message.error("Not registered");
      }
    } catch (error) {
      console.error("Login error: ", error);
      message.error({
        content:
          error.code === "auth/user-not-found"
            ? "User is not registered"
            : error.code === "auth/wrong-password"
              ? "Wrong password entered"
              : error.code === "auth/invalid-login-credentials"
                ? "Wrong email or password"
                : "Wrong email or password",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div className="w-full flex min-h-screen">
        <div className="lg:w-1/2 w-full lg:flex hidden justify-center items-center min-h-screen relative">
          <video
            autoPlay
            loop
            muted
            className="absolute  inset-0 w-full h-full object-cover z-10"
          >
            <source src={video} />
          </video>
          <div className="bg-[#FFFFFF38] w-3/5 p-8 rounded-xl relative z-10">
            <img src={img} alt="" className="" />
          </div>
        </div>
        <div className="lg:w-1/2 md:px-12 px-5 w-full bg-white flex flex-col justify-center items-center gap-2  min-h-screen">
          <img src={Logo} alt="" className="py-4 w-1/5" />

          <div className="space-y-2">
            <h2 className="md:text-3xl text-2xl text-center font-bold text-[#3C404B]">
              {" "}
              Register
            </h2>
            <h2 className=" text-base font-normal text-center text-[#3C404B]">
              {" "}
              Enter your details
            </h2>
          </div>

          <div className="w-full space-y-3">
            <div className="flex flex-col gap-1 py-2 ">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="name"
              >
                Name
              </label>
              <input
                onChange={(e) => setData({ ...data, name: e.target.value })}
                value={data.name}
                type="text"
                className="w-full py-3 px-6 text-base  rounded-md border-[#00000026] border  outline-none active:border-cus-blue focus:border-cus-blue "
                id="name"
                placeholder="Enter your name"
              />
              {data?.name === "" ? (
                <span className="text-xs text-cus-red">Please input name</span>
              ) : null}
            </div>
            <div className="flex flex-col gap-1 py-2 ">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="email"
              >
                E-Mail Address
              </label>
              <input
                onChange={(e) => setData({ ...data, email: e.target.value })}
                value={data?.email}
                type="email"
                className="w-full py-3 px-6 text-base  rounded-md border-[#00000026] border  outline-none active:border-cus-blue focus:border-cus-blue "
                id="email"
                placeholder="Enter your email"
              />
              {data?.email === "" ? (
                <span className="text-xs text-cus-red">Please input email</span>
              ) : null}
            </div>

            <div className="flex flex-col gap-1 py-2 pt-0 ">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="jobTitle"
              >
                Job Title
              </label>
              <div className="relative flex items-center">
                <input
                  onChange={(e) =>
                    setData({ ...data, jobTitle: e.target.value })
                  }
                  value={data?.jobTitle}
                  type="text"
                  className="w-full py-3 px-6 text-base border rounded-md border-[#00000026] outline-none active:border-cus-blue focus:border-cus-blue "
                  id="password"
                  placeholder="Enter job title"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 py-2 pt-0 ">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="company"
              >
                Company
              </label>
              <div className="relative flex items-center">
                <input
                  onChange={(e) =>
                    setData({ ...data, company: e.target.value })
                  }
                  value={data?.company}
                  type="text"
                  className="w-full py-3 px-6 text-base border rounded-md border-[#00000026] outline-none active:border-cus-blue focus:border-cus-blue "
                  id="password"
                  placeholder="Enter company"
                />
              </div>
            </div>
          </div>

          <button
            onClick={handleLogin}
            className="w-full text-sm text-white rounded-md  py-3   btnBg "
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
